import { gql } from "apollo-boost";
import { useQuery } from "react-apollo";
import { getBexApiContext } from "bernie-context";
import { ExtendedContextStore, HSRFilters } from "src/typings/flexFramework/FlexDefinitions";
import { propertyFiltersQueryQuery, PropertyFiltersQuery } from "__generated__/api";
import PropertySearch = PropertyFiltersQuery.PropertySearch;
import { getPropertyTypeCode } from "src/components/utility/ContextUtil";

const propertyFiltersQuery = gql`
  ${propertyFiltersQueryQuery}
`;

function getStructureTypeFilter(context: ExtendedContextStore) {
  const code = getPropertyTypeCode(context);

  const toDashCase = (key: string) => key.replace(/[A-Z]/g, (l) => `_${l.toLowerCase()}`);

  const structureTypes = code?.split(",").map((type) => toDashCase(type).toUpperCase());

  if (!structureTypes) {
    return null;
  }

  switch (true) {
    case structureTypes[0] === "BED_BREAKFAST":
      structureTypes[0] = "BED_AND_BREAKFAST";
      break;
    case structureTypes[0] === "_C_A_P_S_U_L_E__H_O_T_E_L":
      structureTypes[0] = "CAPSULE_HOTEL";
      break;
    case structureTypes[0] === "RYOKEN":
      structureTypes[0] = "RYOKAN";
      break;
  }

  return {
    structureTypes,
  };
}

function getFilterLocation(context: ExtendedContextStore) {
  const location = context.searchContext.location;
  const { latitude, longitude } = location.geoCoordinate || {};
  if (location.type === "point_of_interest") {
    return {
      poi: `${latitude},${longitude}:${location.id}`,
    };
  }

  return {
    neighborhood: `${latitude},${longitude}:${location.id}`,
  };
}
function getSupportAffinityFilters(filters: HSRFilters): HSRFilters {
  const { propertyStyle, ...affinityFilters } = filters;

  if (propertyStyle) return affinityFilters;

  return filters;
}

export function getFilters(context: ExtendedContextStore) {
  const { sort, ...affinityFilters } = getSupportAffinityFilters(context.searchContext.affinity?.bexApiFilters || {});
  const { hsrFilterCode: star } = context.searchContext.starRating || {};
  const starList = star && [Number(star)];

  return {
    sort,
    filters: {
      ...affinityFilters,
      ...getFilterLocation(context),
      ...getStructureTypeFilter(context),
      starList,
    },
  };
}

type Response = { propertySearch: PropertySearch };

export function usePropertySearchQuery(context: ExtendedContextStore) {
  const regionId = context?.searchContext?.location?.id;

  const variables = {
    context: getBexApiContext(context),
    regionId: String(regionId),
    ...getFilters(context),
  };

  return useQuery<Response>(propertyFiltersQuery, {
    variables,
    errorPolicy: "all",
    fetchPolicy: "cache-first",
  });
}

export default usePropertySearchQuery;
